<script>
	import Ribbon from '../../../components/v0/Lobby/Ribbon.svelte';
	import PrimaryButton from '../../../components/v0/Buttons/PrimaryButton.svelte';
	import Container from '../../../components/v0/Container/Container.svelte';
	import UserRow from '../../../components/v0/LeaderboardScreen/UserRow.svelte';
	import SingleUser from '../../../components/v0/LeaderboardScreen/SingleUser.svelte';
	import { onMount, tick } from 'svelte';
	export let isHost = false;
	export let nextRoundOrPlayAgain = '';
	export let continueHandler = () => {
		console.log('pressed continue/play again');
	};
	export let cancelHandler = () => {
		console.log('pressed cancel');
	};
	let showCancel = false;
	export let onMouseDown = () => {};
	export let userId = '';
	export let users = [];
	export let oneLineMessage;
	export let hostName = '';
	let scrolledIntoView = false;
	let myUser = {};
	let myPosition = 0;
	$: {
		for (let i = 0; i < users.length; i++) {
			let temp = users[i].usersArray.find((el) => el.id == userId);
			if (temp) {
				myUser = temp;
				myPosition = i + 1;
				break;
			}
		}
		(async () => {
			await tick();
			scrolledIntoView = isScrolledIntoView(
				document.querySelector('.highlight.notFloating'),
				document.querySelector('.floating')
			);
		})();
	}

	function isScrolledIntoView(el, parent) {
		if (el && parent) {
			var rect = el.getBoundingClientRect();
			var elemBottom = rect.bottom;
			var isVisible = elemBottom < parent.getBoundingClientRect().bottom;
			return isVisible;
		}
		return true;
	}

	onMount(() => {
		scrolledIntoView = isScrolledIntoView(
			document.querySelector('.highlight.notFloating'),
			document.querySelector('.floating')
		);
		document.querySelector('.usersSection').addEventListener('scroll', () => {
			scrolledIntoView = isScrolledIntoView(
				document.querySelector('.highlight.notFloating'),
				document.querySelector('.floating')
			);
		});
	});

	// let isHost = true;

	// let users = [
	// 	{
	// 		position: 1,
	// 		usersArray: [
	// 			{ name: 'abc def', score: 50, src: '' },
	// 			{ name: 'abc def', score: 50 },
	// 			{ name: 'abc def', score: 50 },
	// 			{ name: 'abc def', score: 50 },
	// 			{ name: 'abc def', score: 50 }
	// 		]
	// 	},
	// 	{ position: 2, usersArray: [{ name: 'abc def', score: 40 }] },
	// 	{ position: 3, usersArray: [{ name: 'abc def', score: 30 }] },
	// 	{ position: 4, usersArray: [{ name: 'abc def', score: 20 }] },
	// 	{ position: 5, usersArray: [{ name: 'abc def', score: 10 }] },
	// 	{ position: 6, usersArray: [{ name: 'abc def', score: 0 }] },
	// 	{
	// 		position: 7,
	// 		usersArray: [
	// 			{ name: 'abc def', score: 50 },
	// 			{ name: 'abc def', score: 50 },
	// 			{ name: 'abc def', score: 50 },
	// 			{ name: 'abc def', score: 50 },
	// 			{ name: 'abc def', score: 50 }
	// 		]
	// 	},
	// 	{ position: 8, usersArray: [{ name: 'abc def', score: 0 }] },
	// 	{ position: 9, usersArray: [{ name: 'abc def', score: 0 }] },
	// 	{ position: 10, usersArray: [{ name: 'abc def', score: 0 }] },
	// 	{ position: 11, usersArray: [{ name: 'abc def', score: 0 }] }
	// ];
</script>

<div class="containerWrapper">
	<Container borderRadius="21" padding="0">
		<div style="height:100%;width:100%;padding:0 20px 10px 20px">
			<div class="leaderboardRibbon">
				<Ribbon width="165" height="37" fontSize="18" text="Leaderboard 🏆" />
			</div>
			<div class="oneLineMessage">
				<p>{oneLineMessage}</p>
			</div>
			<div class="usersOuterSection">
				<div class="usersSection">
					{#each users as user}
						<UserRow
							users={user.usersArray}
							position={user.position}
							{userId}
							last={user.position === users.length}
						/>
					{/each}
				</div>
				<div class="floating" class:scrolledIntoView>
					<SingleUser position={myPosition} user={myUser} {userId} notFloating={false} />
				</div>
			</div>
		</div>
	</Container>
</div>
{#if isHost}
	<div class="buttonWrapper">
		{#if showCancel}
			<div class="CancelBtn">
				<PrimaryButton
					{onMouseDown}
					onClick={cancelHandler}
					width={135}
					height={45}
					text="Close App"
					disabled={false}
					fontSize={18}
				/>
			</div>
		{/if}
		<div class="ContinueBtn">
			<PrimaryButton
				{onMouseDown}
				onClick={continueHandler}
				width={135}
				height={45}
				text={nextRoundOrPlayAgain}
				disabled={false}
				fontSize={18}
			/>
		</div>
	</div>
{:else}
	<div style="margin:auto;" class="waitingForHostText">
		<p style="text-align:center;margin-top:1rem;">
			{`Waiting for ${hostName}(Host) to proceed.`}
		</p>
	</div>
{/if}

<style>
	.containerWrapper {
		margin-top: 2rem;
		position: relative;
		margin-left: auto;
		margin-right: auto;
		max-width: 432px;
		height: 392px;
		font-family: 'Work Sans';
		font-weight: 700;
		padding: 0 1rem;
	}
	.leaderboardRibbon {
		position: absolute;
		top: -15px;
		left: 50%;
		transform: translate(-50%);
	}
	.oneLineMessage {
		text-align: center;
		width: 100%;
		margin-top: 2rem;
		font-family: 'Work Sans';
		font-weight: 700;
		font-size: 16px;
		color: rgba(51, 51, 51, 1);
	}
	.usersOuterSection {
		margin-top: 10px;
		height: calc(100% - 4rem);
		position: relative;
	}
	.usersSection {
		width: 100%;
		height: 100%;
		background: rgba(244, 244, 244, 1);
		border-radius: 8px;
		padding: 8px;
		overflow-y: scroll;
	}

	.usersSection > :global(*) + :global(*) {
		margin-top: 8px;
	}
	.buttonWrapper {
		display: flex;
		justify-content: center;
		margin-top: 21px;
	}
	.ContinueBtn {
		margin-left: 1rem;
	}
	::-webkit-scrollbar {
		width: 8px;
		height: 122px;
	}
	::-webkit-scrollbar-thumb {
		background: #6c44a8;
		border-radius: 15px;
	}
	::-webkit-scrollbar-track {
		background: transparent;
		margin-left: 10px;
	}

	::-webkit-scrollbar-track-piece:end {
		background: transparent;
		margin-bottom: 10px;
	}

	::-webkit-scrollbar-track-piece:start {
		background: transparent;
		margin-top: 10px;
	}

	.floating {
		position: absolute;
		bottom: 0;
		width: calc(100% - 24px);
		margin: auto;
		left: 8px;
	}
	.scrolledIntoView {
		visibility: hidden;
	}
	.CancelBtn :global(.primary-btn) {
		background: linear-gradient(45deg, #cbcbcb 50%, #a6a6a6 50%);
		box-shadow: 0px -4px 0px #545454 inset;
	}
	@media only screen and (max-height: 570px) {
		.containerWrapper {
			height: 290px;
		}
	}
</style>
